import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ButtonRadioGroup from '@c/ButtonRadioGroup';

const keys = ['Passport', 'State-issued ID', "State-issued Driver's License"];

const PassportSelector = ({ onChange, value }) => {
  const [selected, setSelected] = useState(value ? keys[0] : null);
  // The value doesn't matter as it's not getting passed to the parent component
  const options = keys.map(key => [key, key]);

  const handleChange = val => {
    setSelected(val);
    onChange(val === keys[0]);
  };

  return <ButtonRadioGroup options={options} onChange={handleChange} value={selected} />;
};

PassportSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool,
};

PassportSelector.defaultProps = {
  value: null,
};

export default PassportSelector;
